// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Topbar shell */

.lb-topbar {
  position: sticky;
  top: 0;
  /* Sticky chrome layer (token --z-sticky). Dropdowns/menus sit above this at
     --z-dropdown; the account menu is additionally height-capped so it never
     climbs over this bar. */
  z-index: var(--z-sticky, 100);
  height: var(--lb-topbar-h, 52px);
  /* Fixed-height chrome must never be squeezed by a page below it in the flex
     column (e.g. a page using min-height:100% over-constrains the column and
     would otherwise shrink the bar). */
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 16px;
  background: var(--bg);
  border-bottom: 1px solid var(--border);
  box-sizing: border-box;
}

.lb-topbar__breadcrumb {
  font-size: var(--fs-meta);
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.lb-topbar__breadcrumb b {
  font-weight: 500;
  color: var(--text-secondary);
}

/* A crumb that navigates is a button stripped back to text, so it inherits the
   breadcrumb's own type and colour. It carries no resting underline: position and
   the "/" separators already read as a trail, and a permanent underline competes
   with the links inside the page. The affordance stays on hover and on keyboard
   focus, where it is the only signal available. */
.lb-topbar__crumb-link {
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
  text-decoration: none;
}
.lb-topbar__crumb-link:hover {
  color: var(--text-secondary);
  text-decoration: underline;
}
.lb-topbar__crumb-link:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
  text-decoration: underline;
}

.lb-topbar__spacer {
  flex: 1;
}

.lb-topbar__pills {
  display: flex;
  align-items: center;
  gap: 6px;
}

.lb-topbar__pill {
  height: 28px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-secondary);
  font-size: var(--fs-meta);
  background: var(--bg-alt);
  cursor: pointer;
  font-family: var(--sans);
  white-space: nowrap;
}

/* Pill deshabilitado (p. ej. "Importar CSV" hasta que exista su backend):
   debe LEERSE como no disponible, no como un botón normal. */
.lb-topbar__pill:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.lb-topbar__pill kbd {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 2px;
  padding: 1px 4px;
  color: var(--text-secondary);
}

/* Icon button: 34×34, transparent, hairline border (--radius-1). */
.lb-topbar__icon {
  width: 34px;
  height: 34px;
  border: 1px solid var(--border);
  border-radius: var(--radius-1, 2px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  background: transparent;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    border-color var(--dur-1, 0.15s) var(--ease, ease),
    color var(--dur-1, 0.15s) var(--ease, ease);
}
.lb-topbar__icon:hover {
  border-color: var(--text);
  color: var(--text);
}

/* Icon button dot: top/right 6px, accent (blue), no halo. */
.lb-topbar__icon-dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 6px;
  height: 6px;
  background: var(--accent);
  border-radius: 999px;
}

/* Search trigger — opens the command palette (⌘K): transparent, hairline
   border, --radius-1 (NOT a pill). */
.lb-topbar__search {
  padding: 7px 11px;
  border: 1px solid var(--border);
  border-radius: var(--radius-1, 2px);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  color: var(--text-muted);
  font-size: var(--fs-ui);
  font-family: var(--sans);
  white-space: nowrap;
  cursor: pointer;
  flex-shrink: 0;
}
.lb-topbar__search:hover {
  color: var(--text);
  border-color: var(--text-muted);
}
.lb-topbar__search kbd {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 2px;
  padding: 1px 4px;
  color: var(--text-muted);
}

/* Notification bell + avisos panel. */
.lb-topbar__bell-wrap {
  position: relative;
  flex-shrink: 0;
}
.lb-topbar__bell-pop {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  width: 300px;
  background: var(--bg-alt);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  z-index: var(--z-dropdown, 1000);
}
.lb-topbar__bell-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-soft);
}
.lb-topbar__bell-kicker {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.lb-topbar__bell-empty {
  padding: 18px 14px;
  font-size: var(--fs-2xs);
  color: var(--text-muted);
}
.lb-topbar__bell-item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px 14px;
  background: transparent;
  border: 0;
  border-bottom: 1px solid var(--border-soft);
  cursor: pointer;
  font: inherit;
}
.lb-topbar__bell-item:hover {
  background: var(--bg);
}
.lb-topbar__bell-txt {
  font-size: var(--fs-ui);
  color: var(--text);
}
.lb-topbar__bell-sub {
  font-size: var(--fs-sm);
  color: var(--text-muted);
  margin-top: 2px;
}
.lb-topbar__bell-foot {
  padding: 11px 14px;
  border-top: 1px solid var(--border-soft);
  font-size: var(--fs-sm);
  line-height: 1.4;
  color: var(--text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/shared/Topbar/Topbar.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,gBAAgB;EAChB,MAAM;EACN;;4BAE0B;EAC1B,6BAA6B;EAC7B,gCAAgC;EAChC;;uCAEqC;EACrC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;;;kDAIkD;AAClD;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;EACT,aAAa;EACb,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;6DAC6D;AAC7D;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,mEAAmE;AACnE;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;;+CAE6C;AAC/C;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;qCACqC;AACrC;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mCAAmC;EACnC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,2CAA2C;EAC3C,eAAe;EACf,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;AAC1B","sourcesContent":["/* Topbar shell */\n\n.lb-topbar {\n  position: sticky;\n  top: 0;\n  /* Sticky chrome layer (token --z-sticky). Dropdowns/menus sit above this at\n     --z-dropdown; the account menu is additionally height-capped so it never\n     climbs over this bar. */\n  z-index: var(--z-sticky, 100);\n  height: var(--lb-topbar-h, 52px);\n  /* Fixed-height chrome must never be squeezed by a page below it in the flex\n     column (e.g. a page using min-height:100% over-constrains the column and\n     would otherwise shrink the bar). */\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  gap: 16px;\n  background: var(--bg);\n  border-bottom: 1px solid var(--border);\n  box-sizing: border-box;\n}\n\n.lb-topbar__breadcrumb {\n  font-size: var(--fs-meta);\n  color: var(--text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.lb-topbar__breadcrumb b {\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n/* A crumb that navigates is a button stripped back to text, so it inherits the\n   breadcrumb's own type and colour. It carries no resting underline: position and\n   the \"/\" separators already read as a trail, and a permanent underline competes\n   with the links inside the page. The affordance stays on hover and on keyboard\n   focus, where it is the only signal available. */\n.lb-topbar__crumb-link {\n  background: none;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n  text-decoration: none;\n}\n.lb-topbar__crumb-link:hover {\n  color: var(--text-secondary);\n  text-decoration: underline;\n}\n.lb-topbar__crumb-link:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n  text-decoration: underline;\n}\n\n.lb-topbar__spacer {\n  flex: 1;\n}\n\n.lb-topbar__pills {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.lb-topbar__pill {\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-full);\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-secondary);\n  font-size: var(--fs-meta);\n  background: var(--bg-alt);\n  cursor: pointer;\n  font-family: var(--sans);\n  white-space: nowrap;\n}\n\n/* Pill deshabilitado (p. ej. \"Importar CSV\" hasta que exista su backend):\n   debe LEERSE como no disponible, no como un botón normal. */\n.lb-topbar__pill:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.lb-topbar__pill kbd {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  padding: 1px 4px;\n  color: var(--text-secondary);\n}\n\n/* Icon button: 34×34, transparent, hairline border (--radius-1). */\n.lb-topbar__icon {\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-1, 2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n  background: transparent;\n  position: relative;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition:\n    border-color var(--dur-1, 0.15s) var(--ease, ease),\n    color var(--dur-1, 0.15s) var(--ease, ease);\n}\n.lb-topbar__icon:hover {\n  border-color: var(--text);\n  color: var(--text);\n}\n\n/* Icon button dot: top/right 6px, accent (blue), no halo. */\n.lb-topbar__icon-dot {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 6px;\n  height: 6px;\n  background: var(--accent);\n  border-radius: 999px;\n}\n\n/* Search trigger — opens the command palette (⌘K): transparent, hairline\n   border, --radius-1 (NOT a pill). */\n.lb-topbar__search {\n  padding: 7px 11px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-1, 2px);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: transparent;\n  color: var(--text-muted);\n  font-size: var(--fs-ui);\n  font-family: var(--sans);\n  white-space: nowrap;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.lb-topbar__search:hover {\n  color: var(--text);\n  border-color: var(--text-muted);\n}\n.lb-topbar__search kbd {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  padding: 1px 4px;\n  color: var(--text-muted);\n}\n\n/* Notification bell + avisos panel. */\n.lb-topbar__bell-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n.lb-topbar__bell-pop {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  width: 300px;\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow);\n  z-index: var(--z-dropdown, 1000);\n}\n.lb-topbar__bell-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border-soft);\n}\n.lb-topbar__bell-kicker {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.lb-topbar__bell-empty {\n  padding: 18px 14px;\n  font-size: var(--fs-2xs);\n  color: var(--text-muted);\n}\n.lb-topbar__bell-item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 10px 14px;\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid var(--border-soft);\n  cursor: pointer;\n  font: inherit;\n}\n.lb-topbar__bell-item:hover {\n  background: var(--bg);\n}\n.lb-topbar__bell-txt {\n  font-size: var(--fs-ui);\n  color: var(--text);\n}\n.lb-topbar__bell-sub {\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n.lb-topbar__bell-foot {\n  padding: 11px 14px;\n  border-top: 1px solid var(--border-soft);\n  font-size: var(--fs-sm);\n  line-height: 1.4;\n  color: var(--text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
